import { render } from "./FormBuilderPage.vue?vue&type=template&id=0ee13bc5"
import script from "./FormBuilderPage.vue?vue&type=script&lang=js"
export * from "./FormBuilderPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__